var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menu-subitem"},[(!_vm.content.children)?_c('router-link',{attrs:{"to":_vm.content.route},nativeOn:{"click":function($event){return _vm.handleClick.apply(null, arguments)}}},[_c('span',[_vm._v(_vm._s(_vm.content.text))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }